export const useLocationPermission = () => {
  const getLocation = async (): Promise<{ lat: number; lng: number }> => {
    return new Promise((resolve, reject) => {
      navigator.geolocation.getCurrentPosition(
        (pos) => {
          resolve({
            lat: pos.coords.latitude,
            lng: pos.coords.longitude,
          });
        },
        (error) => {
          if (error.code === error.PERMISSION_DENIED) {
            reject(new Error("Location permission denied"));
          } else {
            reject(new Error("Unable to fetch location"));
          }
        }
      );
    });
  };

  const checkPermissionAndRun = async (onAllowed: () => void) => {
    try {
      const permission = await navigator.permissions.query({
        name: "geolocation" as PermissionName,
      });

      if (permission.state === "denied") {
        throw new Error("Please enable your location");
      }

      onAllowed();
    } catch (err: any) {
      window.alert(err.message);
    }
  };

  return { checkPermissionAndRun, getLocation };
};